import React from "react"
import Table from "components/table_2"

function TableAndChartView(props) {
  return <Table tableData={{ ...props }} {...props} itemsPerPage={5} />
}

export default TableAndChartView
